import { FullInformationBar } from './FullInformationBar';

export const FullBarGetStarted = ({ onClick }: { onClick: () => void }) => {
  return (
    <FullInformationBar
      onClick={onClick}
      title="Get Listed - No Upfront Cost or Risk"
      message="Join the alluraDirect community today. Our guests are excited to experience new and amazing properties like yours."
      buttonText="Click Here to Get Started"
    />
  );
};
